import { formatJsonDataset as fjd } from '../../components/renderers';

const actions = {
  add: 'Add',
  edit: 'Edit',
  del: 'Delete',
  delete: 'Delete',
  view: 'View',
};

const panels = {
  add: 'simple',
  edit: 'simple',
  delete: 'dialog',
  view: 'simple',
};

const crud = (service: any) => ({
  service: {
    num: true,
    pageMode: 'remote',
    ...service,
  },
  create: true,
  actions,
  panels,
  formatters: { grid: { exi: fjd } },
});

const statusField = () => ({
  id: 'sts',
  label: 'Status',
  type: 'fa',
  req: 1,
  ops: {},
  cp: { t: 'lcs', s: 'status' },
});

const extraInfoField = () => ({
  id: 'exi',
  label: 'Extra Info',
  type: 'jf',
  req: 0,
  ops: {},
});

const truthyField = (id: string, label: string, required = 1) => ({
  id,
  label,
  type: 'fa',
  req: required,
  ops: {},
  cp: { t: 'lcs', s: 'truthy' },
});

const lookupDefinition = (name: string, title: string) =>
  crud({
    name,
    title,
    fields: ['rid','rix','nam','shc','dsc','dcd','exi','sts','ast','stp'],
    params: {
      nam:'Name', shc:'Code', sts:'Status', ast:'Active Status',
    },
    grid: [
      ['nam','Name'], ['shc','Code'], ['dsc','Description'],
      ['sts','Status'], ['stp','Stamp'],
    ],
    menu: {
      mnu: [
        { t:'Name', v:'nam' },
        { t:'Code', v:'shc' },
      ],
      def:'nam',
    },
    eform: [
      { id:'nam', label:'Name', type:'tf', req:1, ops:{} },
      { id:'shc', label:'Code', type:'tf', req:1, ops:{} },
      { id:'dsc', label:'Description', type:'ta', req:0, ops:{} },
      extraInfoField(),
      statusField(),
    ],
  });

const productDefinition = (serviceMode = false) =>
  crud({
    name: serviceMode ? 'service' : 'product',
    title: serviceMode ? 'Services' : 'Products',
    num: false,
    fields: [
      'rid','rix','prc','prn','dsc','pti','ptn','ptc','pci','pcn','pcc',
      'bri','brn','brc','bui','bun','buc','dci','dcn','dcc','sct','act',
      'txi','txr','moq','nts','dcd','exi','sts','ast','stp',
    ],
    params: {
      prc:'Product Code', prn:'Product Name',
      ...(serviceMode ? {} : { pti:'Product Type' }),
      pci:'Product Category', bri:'Brand', sct:'Stock Controlled',
      act:'Allow Cutting', sts:'Status', ast:'Active Status',
    },
    grid: [
      ['prc', serviceMode ? 'Service Code' : 'Product Code'],
      ['prn', serviceMode ? 'Service Name' : 'Product Name'],
      ...(!serviceMode ? [['ptn','Product Type']] : []),
      ['pcn','Category'],
      ['brn','Brand'],
      ['bun','Base Unit'],
      ['sct','Stock Controlled'],
      ['act','Allow Cutting'],
      ['txr','Tax Rate'],
      ['sts','Status'],
      ['stp','Stamp'],
    ],
    menu: {
      mnu: [
        { t: serviceMode ? 'Service Code' : 'Product Code', v:'prc' },
        { t: serviceMode ? 'Service Name' : 'Product Name', v:'prn' },
        { t:'Category', v:'pcn' },
      ],
      def: 'prn',
    },
    eform: [
      { id:'prc', label:serviceMode ? 'Service Code' : 'Product Code', type:'tf', req:1, ops:{} },
      { id:'prn', label:serviceMode ? 'Service Name' : 'Product Name', type:'tf', req:1, ops:{} },
      { id:'dsc', label:'Description', type:'ta', req:0, ops:{} },
      ...(!serviceMode ? [{
        id:'pti', label:'Product Type', type:'fa', req:1, ops:{},
        cp:{ t:'bcs', s:'producttype' },
      }] : []),
      { id:'pci', label:'Product Category', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'productcategory' } },
      { id:'bri', label:'Brand', type:'fa', req:0, ops:{}, cp:{ t:'bcs', s:'brand' } },
      { id:'bui', label:'Base Unit', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'unitofmeasure' } },
      { id:'dci', label:'Discount Category', type:'fa', req:0, ops:{}, cp:{ t:'bcs', s:'discountcategory' } },
      truthyField('sct','Stock Controlled'),
      truthyField('act','Allow Cutting'),
      truthyField('txi','Tax Inclusive'),
      { id:'txr', label:'Tax Rate', type:'nf', req:0, ops:{} },
      { id:'moq', label:'Minimum Order Quantity', type:'nf', req:1, ops:{} },
      { id:'nts', label:'Notes', type:'ta', req:0, ops:{} },
      extraInfoField(),
      statusField(),
    ],
  });

export const catalogconfig = {
  barcodetype: lookupDefinition('barcodetype', 'Barcode Types'),
  product: productDefinition(false),
  service: productDefinition(true),

  productvariant: crud({
    name: 'productvariant',
    title: 'Product Variants',
    fields: [
      'rid','rix','pri','prc','prn','vrc','vrn','uni','unm','unc','idf',
      'wgt','nts','dcd','exi','sts','ast','stp',
    ],
    params: {
      pri:'Product', vrc:'Variant Code', vrn:'Variant Name',
      uni:'Unit', idf:'Default Variant', sts:'Status', ast:'Active Status',
    },
    grid: [
      ['prn','Product'], ['vrc','Variant Code'], ['vrn','Variant Name'],
      ['unm','Unit'], ['idf','Default'], ['wgt','Weight'],
      ['sts','Status'], ['stp','Stamp'],
    ],
    menu: {
      mnu: [
        { t:'Product', v:'prn' },
        { t:'Variant Code', v:'vrc' },
        { t:'Variant Name', v:'vrn' },
      ],
      def:'vrn',
    },
    eform: [
      { id:'pri', label:'Product', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'product' } },
      { id:'vrc', label:'Variant Code', type:'tf', req:1, ops:{} },
      { id:'vrn', label:'Variant Name', type:'tf', req:1, ops:{} },
      { id:'uni', label:'Unit', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'unitofmeasure' } },
      truthyField('idf','Default Variant'),
      { id:'wgt', label:'Weight', type:'nf', req:0, ops:{} },
      { id:'nts', label:'Notes', type:'ta', req:0, ops:{} },
      extraInfoField(),
      statusField(),
    ],
  }),

  productvariantdimension: crud({
    name: 'productvariantdimension',
    title: 'Product Variant Dimensions',
    fields: [
      'rid','rix','vri','vrc','vrn','pri','prc','prn','dti','dtn','dtc',
      'dvl','uni','unm','unc','tol','nts','dcd','exi','sts','ast','stp',
    ],
    params: {
      vri:'Product Variant', dti:'Dimension Type', uni:'Unit',
      sts:'Status', ast:'Active Status',
    },
    grid: [
      ['prn','Product'], ['vrn','Variant'], ['dtn','Dimension'],
      ['dvl','Value'], ['unc','Unit'], ['tol','Tolerance'],
      ['sts','Status'], ['stp','Stamp'],
    ],
    menu: {
      mnu: [
        { t:'Product', v:'prn' },
        { t:'Variant', v:'vrn' },
        { t:'Dimension', v:'dtn' },
      ],
      def:'prn',
    },
    eform: [
      { id:'vri', label:'Product Variant', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'productvariant' } },
      { id:'dti', label:'Dimension Type', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'dimensiontype' } },
      { id:'dvl', label:'Dimension Value', type:'nf', req:1, ops:{} },
      { id:'uni', label:'Unit', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'unitofmeasure' } },
      { id:'tol', label:'Tolerance', type:'nf', req:0, ops:{} },
      { id:'nts', label:'Notes', type:'ta', req:0, ops:{} },
      extraInfoField(),
      statusField(),
    ],
  }),

  productvariantattribute: crud({
    name: 'productvariantattribute',
    title: 'Product Variant Attributes',
    fields: [
      'rid','rix','vri','vrc','vrn','pri','prc','prn','ati','atn','atc',
      'avi','avn','avc','avl','dcd','exi','sts','ast','stp',
    ],
    params: {
      vri:'Product Variant', ati:'Product Attribute',
      avi:'Attribute Value', sts:'Status', ast:'Active Status',
    },
    grid: [
      ['prn','Product'], ['vrn','Variant'], ['atn','Attribute'],
      ['avn','Defined Value'], ['avl','Custom Value'],
      ['sts','Status'], ['stp','Stamp'],
    ],
    menu: {
      mnu: [
        { t:'Product', v:'prn' },
        { t:'Variant', v:'vrn' },
        { t:'Attribute', v:'atn' },
      ],
      def:'prn',
    },
    eform: [
      { id:'vri', label:'Product Variant', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'productvariant' } },
      { id:'ati', label:'Product Attribute', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'productattribute' } },
      { id:'avi', label:'Defined Attribute Value', type:'fa', req:0, ops:{}, cp:{ t:'bcs', s:'productattributevalue' } },
      { id:'avl', label:'Custom Attribute Value', type:'tf', req:0, ops:{} },
      extraInfoField(),
      statusField(),
    ],
  }),

  productbarcode: crud({
    name: 'productbarcode',
    title: 'Product Barcodes',
    fields: [
      'rid','rix','vri','vrc','vrn','pri','prc','prn','bar','bty','ipr',
      'dcd','exi','sts','ast','stp','bti','btc',
    ],
    params: {
      vri:'Product Variant', bar:'Barcode', bti:'Barcode Type', ipr:'Primary Barcode',
      sts:'Status', ast:'Active Status',
    },
    grid: [
      ['prn','Product'], ['vrn','Variant'], ['bar','Barcode'],
      ['bty','Barcode Type'], ['ipr','Primary'],
      ['sts','Status'], ['stp','Stamp'],
    ],
    menu: {
      mnu: [
        { t:'Product', v:'prn' },
        { t:'Variant', v:'vrn' },
        { t:'Barcode', v:'bar' },
      ],
      def:'bar',
    },
    eform: [
      { id:'vri', label:'Product Variant', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'productvariant' } },
      { id:'bar', label:'Barcode', type:'tf', req:1, ops:{} },
      { id:'bti', label:'Barcode Type', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'barcodetype' } },
      truthyField('ipr','Primary Barcode'),
      extraInfoField(),
      statusField(),
    ],
  }),

  productmedia: crud({
    name: 'productmedia',
    title: 'Product Media',
    fields: [
      'rid','rix','pri','prc','prn','vri','vrc','vrn','nam','mty','url',
      'ipr','sor','dcd','exi','sts','ast','stp',
    ],
    params: {
      pri:'Product', vri:'Product Variant', nam:'Media Name',
      mty:'Media Type', ipr:'Primary Media', sts:'Status', ast:'Active Status',
    },
    grid: [
      ['prn','Product'], ['vrn','Variant'], ['nam','Media Name'],
      ['mty','Media Type'], ['url','Media URL'], ['ipr','Primary'],
      ['sor','Sort Order'], ['sts','Status'], ['stp','Stamp'],
    ],
    menu: {
      mnu: [
        { t:'Product', v:'prn' },
        { t:'Media Name', v:'nam' },
        { t:'Media Type', v:'mty' },
      ],
      def:'nam',
    },
    eform: [
      { id:'pri', label:'Product', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'product' } },
      { id:'vri', label:'Product Variant', type:'fa', req:0, ops:{}, cp:{ t:'bcs', s:'productvariant' } },
      { id:'nam', label:'Media Name', type:'tf', req:1, ops:{} },
      { id:'mty', label:'Media Type', type:'tf', req:1, ops:{} },
      { id:'url', label:'Media URL', type:'tf', req:1, ops:{} },
      truthyField('ipr','Primary Media'),
      { id:'sor', label:'Sort Order', type:'nf', req:1, ops:{} },
      extraInfoField(),
      statusField(),
    ],
  }),

  pricelist: crud({
    name: 'pricelist',
    title: 'Price Lists',
    fields: [
      'rid','rix','nam','shc','dsc','cur','efd','exd','idf','txi',
      'dcd','exi','sts','ast','stp','cri','crn',
    ],
    params: {
      nam:'Name', shc:'Code', cri:'Currency', idf:'Default Price List',
      sdt:'Start Date', edt:'End Date', sts:'Status', ast:'Active Status',
    },
    grid: [
      ['nam','Name'], ['shc','Code'], ['cur','Currency'],
      ['efd','Effective Date'], ['exd','Expiry Date'], ['idf','Default'],
      ['txi','Tax Inclusive'], ['sts','Status'], ['stp','Stamp'],
    ],
    menu: {
      mnu: [
        { t:'Name', v:'nam' },
        { t:'Code', v:'shc' },
        { t:'Currency', v:'cur' },
      ],
      def:'nam',
    },
    eform: [
      { id:'nam', label:'Name', type:'tf', req:1, ops:{} },
      { id:'shc', label:'Code', type:'tf', req:1, ops:{} },
      { id:'dsc', label:'Description', type:'ta', req:0, ops:{} },
      { id:'cri', label:'Currency', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'currency' } },
      { id:'efd', label:'Effective Date', type:'df', req:1, ops:{} },
      { id:'exd', label:'Expiry Date', type:'df', req:0, ops:{} },
      truthyField('idf','Default Price List'),
      truthyField('txi','Tax Inclusive'),
      extraInfoField(),
      statusField(),
    ],
  }),

  pricelistitem: crud({
    name: 'pricelistitem',
    title: 'Price List Items',
    fields: [
      'rid','rix','pli','pln','plc','vri','vrc','vrn','pri','prc','prn',
      'uni','unm','unc','unp','mqt','efd','exd','txi','nts','dcd','exi',
      'sts','ast','stp',
    ],
    params: {
      pli:'Price List', vri:'Product Variant', uni:'Unit',
      sdt:'Start Date', edt:'End Date', sts:'Status', ast:'Active Status',
    },
    grid: [
      ['pln','Price List'], ['prn','Product'], ['vrn','Variant'],
      ['unm','Unit'], ['unp','Unit Price'], ['mqt','Minimum Quantity'],
      ['efd','Effective Date'], ['exd','Expiry Date'], ['txi','Tax Inclusive'],
      ['sts','Status'], ['stp','Stamp'],
    ],
    menu: {
      mnu: [
        { t:'Price List', v:'pln' },
        { t:'Product', v:'prn' },
        { t:'Variant', v:'vrn' },
      ],
      def:'pln',
    },
    eform: [
      { id:'pli', label:'Price List', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'pricelist' } },
      { id:'vri', label:'Product Variant', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'productvariant' } },
      { id:'uni', label:'Unit', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'unitofmeasure' } },
      { id:'unp', label:'Unit Price', type:'nf', req:1, ops:{} },
      { id:'mqt', label:'Minimum Quantity', type:'nf', req:1, ops:{} },
      { id:'efd', label:'Effective Date', type:'df', req:1, ops:{} },
      { id:'exd', label:'Expiry Date', type:'df', req:0, ops:{} },
      truthyField('txi','Tax Inclusive'),
      { id:'nts', label:'Notes', type:'ta', req:0, ops:{} },
      extraInfoField(),
      statusField(),
    ],
  }),

  cuttingrate: crud({
    name: 'cuttingrate',
    title: 'Cutting Rates',
    fields: [
      'rid','rix','spi','spc','spn','api','apc','apn','pci','pcn','pcc',
      'cht','uni','unm','unc','ram','mnc','miv','mav','efd','exd','nts',
      'dcd','exi','sts','ast','stp',
    ],
    params: {
      spi:'Service', api:'Applicable Product', pci:'Product Category',
      cht:'Charge Type', sdt:'Start Date', edt:'End Date',
      sts:'Status', ast:'Active Status',
    },
    grid: [
      ['spn','Service'], ['apn','Applicable Product'], ['pcn','Category'],
      ['cht','Charge Type'], ['unm','Unit'], ['ram','Rate Amount'],
      ['mnc','Minimum Charge'], ['efd','Effective Date'], ['exd','Expiry Date'],
      ['sts','Status'], ['stp','Stamp'],
    ],
    menu: {
      mnu: [
        { t:'Service', v:'spn' },
        { t:'Applicable Product', v:'apn' },
        { t:'Charge Type', v:'cht' },
      ],
      def:'spn',
    },
    eform: [
      { id:'spi', label:'Service', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'service' } },
      { id:'api', label:'Applicable Product', type:'fa', req:0, ops:{}, cp:{ t:'bcs', s:'product' } },
      { id:'pci', label:'Product Category', type:'fa', req:0, ops:{}, cp:{ t:'bcs', s:'productcategory' } },
      { id:'cht', label:'Charge Type', type:'fa', req:1, ops:{}, cp:{ t:'lcs', s:'cuttingchargetype' } },
      { id:'uni', label:'Unit', type:'fa', req:0, ops:{}, cp:{ t:'bcs', s:'unitofmeasure' } },
      { id:'ram', label:'Rate Amount', type:'nf', req:1, ops:{} },
      { id:'mnc', label:'Minimum Charge', type:'nf', req:1, ops:{} },
      { id:'miv', label:'Minimum Value', type:'nf', req:0, ops:{} },
      { id:'mav', label:'Maximum Value', type:'nf', req:0, ops:{} },
      { id:'efd', label:'Effective Date', type:'df', req:1, ops:{} },
      { id:'exd', label:'Expiry Date', type:'df', req:0, ops:{} },
      { id:'nts', label:'Notes', type:'ta', req:0, ops:{} },
      extraInfoField(),
      statusField(),
    ],
  }),

  productbundle: crud({
    name: 'productbundle',
    title: 'Product Bundles',
    fields: [
      'rid','rix','bpi','bpc','bpn','dsc','efd','exd','nts','dcd',
      'exi','sts','ast','stp',
    ],
    params: {
      bpi:'Bundle Product', sdt:'Start Date', edt:'End Date',
      sts:'Status', ast:'Active Status',
    },
    grid: [
      ['bpc','Bundle Code'], ['bpn','Bundle Product'], ['dsc','Description'],
      ['efd','Effective Date'], ['exd','Expiry Date'],
      ['sts','Status'], ['stp','Stamp'],
    ],
    menu: {
      mnu: [
        { t:'Bundle Code', v:'bpc' },
        { t:'Bundle Product', v:'bpn' },
      ],
      def:'bpn',
    },
    eform: [
      { id:'bpi', label:'Bundle Product', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'product' } },
      { id:'dsc', label:'Description', type:'ta', req:0, ops:{} },
      { id:'efd', label:'Effective Date', type:'df', req:1, ops:{} },
      { id:'exd', label:'Expiry Date', type:'df', req:0, ops:{} },
      { id:'nts', label:'Notes', type:'ta', req:0, ops:{} },
      extraInfoField(),
      statusField(),
    ],
  }),

  productbundleitem: crud({
    name: 'productbundleitem',
    title: 'Product Bundle Items',
    fields: [
      'rid','rix','pbi','bpi','bpc','bpn','vri','vrc','vrn','cpi','cpc',
      'cpn','qty','uni','unm','unc','iop','nts','dcd','exi','sts','ast','stp',
    ],
    params: {
      pbi:'Product Bundle', vri:'Product Variant', iop:'Optional Item',
      sts:'Status', ast:'Active Status',
    },
    grid: [
      ['bpn','Bundle'], ['cpn','Component Product'], ['vrn','Variant'],
      ['qty','Quantity'], ['unm','Unit'], ['iop','Optional'],
      ['sts','Status'], ['stp','Stamp'],
    ],
    menu: {
      mnu: [
        { t:'Bundle', v:'bpn' },
        { t:'Component Product', v:'cpn' },
        { t:'Variant', v:'vrn' },
      ],
      def:'bpn',
    },
    eform: [
      { id:'pbi', label:'Product Bundle', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'productbundle' } },
      { id:'vri', label:'Component Variant', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'productvariant' } },
      { id:'qty', label:'Quantity', type:'nf', req:1, ops:{} },
      { id:'uni', label:'Unit', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'unitofmeasure' } },
      truthyField('iop','Optional Item'),
      { id:'nts', label:'Notes', type:'ta', req:0, ops:{} },
      extraInfoField(),
      statusField(),
    ],
  }),

  productaccessory: crud({
    name: 'productaccessory',
    title: 'Product Accessories',
    fields: [
      'rid','rix','pri','prc','prn','api','apc','apn','rqt','irq','nts',
      'dcd','exi','sts','ast','stp',
    ],
    params: {
      pri:'Product', api:'Accessory Product', irq:'Required Accessory',
      sts:'Status', ast:'Active Status',
    },
    grid: [
      ['prn','Product'], ['apn','Accessory Product'],
      ['rqt','Recommended Quantity'], ['irq','Required'],
      ['sts','Status'], ['stp','Stamp'],
    ],
    menu: {
      mnu: [
        { t:'Product', v:'prn' },
        { t:'Accessory Product', v:'apn' },
      ],
      def:'prn',
    },
    eform: [
      { id:'pri', label:'Product', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'product' } },
      { id:'api', label:'Accessory Product', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'product' } },
      { id:'rqt', label:'Recommended Quantity', type:'nf', req:1, ops:{} },
      truthyField('irq','Required Accessory'),
      { id:'nts', label:'Notes', type:'ta', req:0, ops:{} },
      extraInfoField(),
      statusField(),
    ],
  }),
};

export default catalogconfig;
